import { render, staticRenderFns } from "./RecentActivityTableDescriptionCreditNoteIssued.vue?vue&type=template&id=fdfdd54e&"
import script from "./RecentActivityTableDescriptionCreditNoteIssued.vue?vue&type=script&lang=js&"
export * from "./RecentActivityTableDescriptionCreditNoteIssued.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports